var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';

import CustomNewField from './CustomInstanceNewField';
import CustomField from './fields/CustomField';
import EmptyContent from './EmptyContent';

import { FIELD_TYPE_STRING } from './constants';

var CustomInstance = function (_React$PureComponent) {
    _inherits(CustomInstance, _React$PureComponent);

    function CustomInstance(props) {
        _classCallCheck(this, CustomInstance);

        var _this = _possibleConstructorReturn(this, (CustomInstance.__proto__ || Object.getPrototypeOf(CustomInstance)).call(this, props));

        _this.onFieldChange = function (key, value) {
            var _this$props = _this.props,
                canEdit = _this$props.canEdit,
                onFieldChange = _this$props.onFieldChange;

            if (canEdit && onFieldChange) {
                onFieldChange(key, value, FIELD_TYPE_STRING);
            }
        };

        _this.onFieldRemove = function (key) {
            var _this$props2 = _this.props,
                canEdit = _this$props2.canEdit,
                onFieldRemove = _this$props2.onFieldRemove;

            if (canEdit && onFieldRemove) {
                onFieldRemove(key);
            }
        };

        _this.onAddFieldToggle = function () {
            _this.setState(function (prevState) {
                return {
                    isAddFieldVisible: !prevState.isAddFieldVisible
                };
            });
        };

        _this.state = {
            isAddFieldVisible: false,
            properties: _extends({}, props.data)
        };
        return _this;
    }

    _createClass(CustomInstance, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                isAddFieldVisible: false,
                properties: _extends({}, nextProps.data)
            });
        }

        /**
         * Adds/updates a new metadata key value pair
         *
         * @param {string} key - metadata key
         * @param {string} value - metadata value
         * @return {void}
         */


        /**
         * Adds/updates a new metadata key value pair
         *
         * @param {string} key - metadata key
         * @param {string} value - metadata value
         * @return {void}
         */


        /**
         * Shows the add new field field
         *
         * @return {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var canEdit = this.props.canEdit;
            var _state = this.state,
                isAddFieldVisible = _state.isAddFieldVisible,
                properties = _state.properties;

            var fields = Object.keys(properties);
            var canAddFields = canEdit && (isAddFieldVisible || fields.length === 0);

            return React.createElement(
                React.Fragment,
                null,
                fields.map(function (key, index) {
                    return React.createElement(CustomField, {
                        key: key,
                        isLast: !isAddFieldVisible && index === fields.length - 1,
                        canEdit: canEdit,
                        dataKey: key,
                        dataValue: properties[key],
                        onChange: _this2.onFieldChange,
                        onRemove: _this2.onFieldRemove,
                        onAdd: _this2.onAddFieldToggle
                    });
                }),
                !canAddFields && fields.length === 0 && React.createElement(EmptyContent, null),
                canAddFields && React.createElement(CustomNewField, {
                    isCancellable: fields.length !== 0,
                    properties: this.props.data,
                    onAdd: this.onFieldChange,
                    onCancel: this.onAddFieldToggle
                })
            );
        }
    }]);

    return CustomInstance;
}(React.PureComponent);

CustomInstance.defaultProps = {
    canEdit: true,
    data: {}
};
CustomInstance.propTypes = {
    canEdit: PropTypes.bool.isRequired,
    onFieldChange: PropTypes.func,
    onFieldRemove: PropTypes.func,
    data: function data() {
        return (typeof bpfrpt_proptype_Fields === 'function' ? bpfrpt_proptype_Fields.isRequired ? bpfrpt_proptype_Fields.isRequired : bpfrpt_proptype_Fields : PropTypes.shape(bpfrpt_proptype_Fields).isRequired).apply(this, arguments);
    }
};


export default CustomInstance;
import { bpfrpt_proptype_Fields } from './flowTypes';
import { bpfrpt_proptype_FieldValue } from './flowTypes';
import PropTypes from 'prop-types';